import { useStore } from 'vuex';
import { useCampaignStore } from '../stores/campaign';
import { findVariantByOrigin } from '../utils/variant';
import { parseTemplateInfoBy } from '../utils/template';
import { ProviderSource } from '../types/template';

export const useVariantThemePage = () => {
  const store = useStore();
  const campaignStore = useCampaignStore();

  const campaign = computed(() => campaignStore.getters.getCampaignThemePage);
  const variantA = computed(() => findVariantByOrigin(campaign.value, true));
  const themePageId = computed(() => store.state.app.pageInfo.page.g_id);
  const variantB = computed(() => findVariantByOrigin(campaign.value, false));
  const templateSuffixA = computed(() => variantA.value?.templateSuffix);
  const templateSuffixB = computed(() => variantB.value?.templateSuffix);
  const isMatchedThemePageA = computed(() => {
    return templateSuffixA.value?.includes(themePageId.value);
  });
  const isMatchedThemePageB = computed(() => {
    return templateSuffixB.value?.includes(themePageId.value);
  });
  const isThemePageAV6 = computed(() => {
    const templateInfo = parseTemplateInfoBy({
      templateSuffix: templateSuffixA.value,
    });
    return templateInfo?.providerSource === ProviderSource.GEMPAGESV6;
  });
  const isThemePageBV6 = computed(() => {
    const templateInfo = parseTemplateInfoBy({
      templateSuffix: templateSuffixB.value,
    });
    return templateInfo?.providerSource === ProviderSource.GEMPAGESV6;
  });

  return {
    campaign,
    variantA,
    variantB,
    themePageId,
    templateSuffixA,
    templateSuffixB,
    isThemePageAV6,
    isThemePageBV6,
    isMatchedThemePageA,
    isMatchedThemePageB,
  };
};
